const ClientError = require('./error')
const utils = require('../lib/utils')
const TranslationManager = require('../lib/translationManager')
const requireTranslation = require.context('../i18next/', true, /^\.\/.*\.js$/)

let translations = utils.language.requireTranslations(requireTranslation)


class ClientTranslationManager extends TranslationManager {
    constructor() {
        super()
    }

    /**
     * initialize all languages including the given app translations
     *
     * @param appTranslations		object - translations of the following format: {<langCode>: {<i18next-namespace>: {<translationKey>: <translationValue>}}}
     */
    init(appTranslations = {}) {
        if (this.initialized) {
            throw new ClientError('TRANSLATION_MANAGER_MULTI_INIT_ERROR')
        }
        this.initialized = true
        super.init(translations, appTranslations)

        // free up some resource
        translations = null
    }

    /**
     * returns a function according to the given langCode used for translating an i18next key.
     * if the langCode is empty or the corresponding translator could not be found an error message will be logged.
     *
     * @see https://www.i18next.com/overview/api#t
     *
     * @param langCode		string - langCode
     * @returns {(function(i18nextKeys, i18nextOptions): void)}
     */
    getTranslator(langCode){
        if(!this.initialized){
            throw new ClientError('TRANSLATION_MANAGER_TRANSLATOR_NOT_AVAILABLE_PRIOR_TO_INITIALIZATION', `langCode: ${langCode}`)
        }

        return super.getTranslator(langCode)
    }
}

module.exports = (globalThis.translationManager = new ClientTranslationManager())